var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLiquidation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5444_9065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 7H14L15.4812 4.77812C15.7031 4.44375 15.4656 4 15.0656 4H8.93437C8.53437 4 8.29688 4.44375 8.51875 4.77812L10 7ZM14 8H10C9.88125 8.07812 9.74687 8.16562 9.59375 8.2625C7.82188 9.39687 4 11.8406 4 17C4 18.6562 5.34375 20 7 20H17C18.6562 20 20 18.6562 20 17C20 11.8406 16.1781 9.39687 14.4062 8.2625C14.2563 8.16562 14.1187 8.07812 14 8ZM13.0594 14.5L14.5281 15.9688C14.8219 16.2625 14.8219 16.7375 14.5281 17.0281C14.2344 17.3187 13.7594 17.3219 13.4688 17.0281L12 15.5594L10.5312 17.0281C10.2375 17.3219 9.7625 17.3219 9.47188 17.0281C9.18125 16.7344 9.17813 16.2594 9.47188 15.9688L10.9406 14.5L9.47188 13.0312C9.17813 12.7375 9.17813 12.2625 9.47188 11.9719C9.76562 11.6813 10.2406 11.6781 10.5312 11.9719L12 13.4406L13.4688 11.9719C13.7625 11.6781 14.2375 11.6781 14.5281 11.9719C14.8187 12.2656 14.8219 12.7406 14.5281 13.0312L13.0594 14.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5444_9065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLiquidation);
export default __webpack_public_path__ + "static/media/icon-liquidation.348eb5ac8fa360c9f36825abfd04a662.svg";
export { ForwardRef as ReactComponent };